import { trimHttp } from '../utils';
import cookie from '../utils/cookie';
import {
    SET_LOGIN_INFO,
    SET_COUPON_SELECTED,
    SET_PAY_GLOBAL,
    SET_UP_RELATION,
    SET_FOLLOW_STAT,
    SET_FOLLOW_STATUS
} from './types';

export default {
    [SET_LOGIN_INFO](state, loginData) {
        state.loginInfo = {
            isLogin: loginData.isLogin || false,
            face: trimHttp(loginData.face || ''),
            uname: loginData.uname || '',
            mid: loginData.mid || cookie.get('DedeUserID'),
            isVip: (loginData.vipType === 1 || loginData.vipType === 2) && loginData.vipStatus === 1,
            levelInfo: loginData.level_info || {},
            level: loginData.level_info && loginData.level_info.current_level,
            vipType: loginData.vipType,
            vipStatus: loginData.vipStatus,
            mobileVerified: loginData.mobile_verified,
            vip: loginData.vip,
            official: loginData.official
        };
        // sentry上报记录用户信息
        if (process.env.VUE_ENV === 'client') {
            if (window && window.Sentry) {
                window.Sentry.configureScope(function(scope) {
                    scope.setUser({
                        mid: state.loginInfo.mid || '',
                        uname: state.loginInfo.uname || ''
                    });
                });
            }
        }

        state.isLogin = loginData.isLogin || false;
    },
    [SET_COUPON_SELECTED](state, selected) {
        state.couponSelected = Object.assign({}, state.couponSelected, selected);
    },
    [SET_PAY_GLOBAL](state, pay) {
        state.payGlobal = Object.assign({}, state.payGlobal, pay);
    },
    [SET_UP_RELATION](state, res) {
        if (res.followed === undefined) {
            state.userState.upFollowed = res.attribute === 1 || res.attribute === 2 || res.attribute === 6;
        } else {
            state.userState.upFollowed = res.followed;
        }
        state.userState.upAttr = res.attribute;
    },
    [SET_FOLLOW_STAT](state, { followed, status }) {
        state.userState.followed = followed;
        if (status !== undefined) {
            state.userState.followStatus = status;
        }
    },
    [SET_FOLLOW_STATUS](state, status) {
        if (status !== undefined) {
            state.userState.followStatus = status;
        }
    }
};